import React, { Component, PropTypes } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { connect } from 'react-redux'

/* Polyfills */
import requestFrame from 'request-frame'
import smoothscroll from 'smoothscroll-polyfill'

import { storeScrollPositionAction } from '../../gallery/actions'
import { isAuthenticated } from '../../gallery/selectors'

import ErrorPage from '../../gallery/components/ErrorPage'
import Menu from '../../gallery/components/Menu'

import '../../css/base.css'
import '../../css/errorPage.css'
import '../../css/footer.css'
import '../../css/gallery.css'
import '../../css/hover.css'
import '../../css/login.css'
import '../../css/menu.css'
import '../../css/personDetail.css'
import '../../css/transitions.css'

requestFrame('native')
smoothscroll.polyfill()

const mapStateToProps = (state) => ({
  isAuthenticated: isAuthenticated(state),
})

const mapDispatchToProps = dispatch => ({
  handleScroll () {
    dispatch(storeScrollPositionAction(
      document.documentElement.scrollTop || document.body.scrollTop
    ))
  },
})

class BaseApp extends Component {

  static propTypes = {
    children: PropTypes.element.isRequired,
    location: PropTypes.object.isRequired,
    handleScroll: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
  }

  setupScrollMemory (pathname, previousHandleScroll, newHandleScroll) {
    if (previousHandleScroll) {
      console.log('removing display scroll')
      window.removeEventListener('scroll', previousHandleScroll)
    }
    if (pathname === '/gallery') {
      console.log('adding display scroll')
      window.addEventListener('scroll', newHandleScroll)
    }
  }

  componentDidMount () {
    const { pathname } = this.props.location
    const { handleScroll } = this.props
    this.setupScrollMemory(pathname, null, handleScroll)
  }

  componentWillReceiveProps (nextProps) {
    const { pathname } = nextProps.location
    const { handleScroll } = nextProps
    const previousHandleScroll = this.props.handleScroll
    this.setupScrollMemory(pathname, previousHandleScroll, handleScroll)
  }

  renderPermited () {
    const { children, isAuthenticated, location } = this.props
    const protectedRoutesMatch = /^\/gallery(\/[a-zA-Z]+-[a-zA-Z]+\/?)?$/
    const isProtectedRoutes = protectedRoutesMatch.test(location.pathname)
    if (!isProtectedRoutes || isAuthenticated) {
      return React.cloneElement(children, {key: location.pathname})
    }
    return React.cloneElement(<ErrorPage />, {key: 'permissionDenied'})
  }

  render () {
    return (
      <div>
        <Menu />
        <ReactCSSTransitionGroup
          className='page-content'
          component='div'
          transitionName='page-content'
          transitionEnterTimeout={600}
          transitionLeaveTimeout={600}
        >
          {this.renderPermited()}
        </ReactCSSTransitionGroup>
      </div>
    )
  }
}

const App = connect(mapStateToProps, mapDispatchToProps)(BaseApp)

export default App



// WEBPACK FOOTER //
// ./src/site/components/App.js